import trOrtak from './tr/ortak.json' with { type: 'json' };
import trAuth from './tr/auth.json' with { type: 'json' };
import enOrtak from './en/ortak.json' with { type: 'json' };
import enAuth from './en/auth.json' with { type: 'json' };
export const kaynaklar = {
    tr: { ortak: trOrtak, auth: trAuth },
    en: { ortak: enOrtak, auth: enAuth },
};
export const desteklenenDiller = ['tr', 'en'];
export const varsayilanDil = 'tr';
//# sourceMappingURL=index.js.map